<template>
  <div class="popup" @click="$emit('deselectAsset')">
    <div class="popup__inner" @click.stop="() => {}">
      <div class="popup__thumb mb-2">
        <img :src="assetUrl" alt="">
      </div>
      <div class="popup__path mb-2">
        <label>Description</label>
        <input class="form-control w-100" type="text" v-model="asset.description">
      </div>
      <div class="popup__category mb-2">
        <label>Category</label>
        <select class="form-control" name="" id="" v-model="asset.category">
          <option value="background">Background</option>
          <option value="minimapImage">Minimap Image</option>
          <option value="misc">Misc</option>
          <option value="pageBackground">Page Background</option>
          <option value="pageSidebarImage">Page Sidebar Image</option>
          <option value="restMedia">Rest Media</option>
          <option value="tagImage">Tag Image</option>
        </select>
      </div>
      <div class="popup__thumbpath mb-2">
        <label>Thumbnail Path</label>
        <input class="form-control w-100" type="text" v-model="asset.thumbPath">
      </div>
      <div v-if="asset.type === 'video'" class="popup__thumbpath mb-2">
        <label>Custom Video Thumbnail Path</label>
        <input class="form-control w-100" type="text" v-model="asset.customThumbPath">
      </div>
      <div class="d-flex mt-4">
        <button class="btn btn-primary" @click="$store.dispatch('UPDATE_ASSET', asset)">Save</button>
        <button class="btn btn-primary ml-auto" @click="$emit('deselectAsset')">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['asset'],

  computed: {
    assetUrl () {
      const thumbnail = this.asset.customThumbPath ? this.asset.customThumbPath : this.asset.thumbPath
      return this.$store.state.assetsPath + thumbnail
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  color: #fff;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;

  &__inner {
    background: #1a202c;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    margin: 20px 0;
    max-height: calc(100vh - 40px);
    overflow: auto;
    padding: 20px;

    @media screen and (min-width: 992px) {
      margin: 20px 0 20px 260px;
    }
  }

  &__thumb {
    background-image:
      linear-gradient(to right, rgba(230, 237, 245, 0.85), rgba(230, 237, 245, 0.85)),
      linear-gradient(to right, #000 50%, #fff 50%),
      linear-gradient(to bottom, #000 50%, #fff 50%);
    background-blend-mode: normal, difference, normal;
    background-size: 1em 1em;
    border-radius: 3px;
    overflow: hidden;

    img {
      max-height: 300px;
      object-fit: contain;
      width: 400px;
    }
  }

  label {
    color: #fff;
  }
}
</style>